import { CaretDown, Check } from "@phosphor-icons/react";
import { useState } from "react";

import { MenuSearchInput } from "common/components/MenuSearchInput";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import ProfileImage from "common/components/ui/ProfileImage";
import type { LinkedInProfile } from "common/types";

export default function SenderProfile({
  profileOptions,
  senderProfile,
  setSenderProfile,
}: {
  profileOptions: LinkedInProfile[];
  senderProfile: LinkedInProfile;
  setSenderProfile: (senderProfile: LinkedInProfile) => void;
}) {
  const [searchText, setSearchText] = useState("");

  const { picture_url: pictureUrl, full_name: fullName } = senderProfile ?? {};

  if (profileOptions.length === 1) {
    return (
      <div className="ml-1 flex items-center gap-x-2">
        <ProfileImage src={pictureUrl} />
        <span className="flex-1 text-sm-bold">{fullName} (You)</span>
      </div>
    );
  }

  const filteredProfileOptions = profileOptions
    ? profileOptions.filter((option) =>
        option.full_name.toLowerCase().includes(searchText.toLowerCase()),
      )
    : [];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="group flex items-center gap-1 rounded-full p-1 pr-3 transition-[background] data-[state=open]:bg-black-100 hover:bg-black-100">
        <ProfileImage src={pictureUrl} className="mr-1" />
        <span className="flex-1 text-sm-bold">{fullName} (You)</span>
        <CaretDown className="ml-1 size-4 transition-transform group-data-[state=open]:rotate-180" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="z-aboveDialog" align="start">
        {profileOptions.length > 5 && (
          <MenuSearchInput
            value={searchText}
            onChange={({ target: { value } }) => setSearchText(value)}
          />
        )}
        <DropdownMenuList>
          {filteredProfileOptions.map((option) => (
            <DropdownMenuItem
              key={option.id}
              onSelect={() => setSenderProfile(option)}
            >
              <ProfileImage src={option.picture_url} size="2xs" />
              {option.full_name}
              {option.id === senderProfile.id && (
                <Check className="ml-auto size-5" />
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
